export const getSupportsBrowserSignIn = (): boolean =>
  typeof window.electron?.openInBrowser === 'function';
